export const searchFilter = {
    init() {
        document.addEventListener('DOMContentLoaded', () => {
            const ifFoerdersuche = document.querySelector('.foerdersuche');
            const ifChargingStations = document.querySelector('.chargingstations');
            if (ifFoerdersuche) {
                this.foerderSuche();
            }
            if (ifChargingStations) {
                this.chargingStations();
            }
        });
    },
    foerderSuche() {
        const currentPage = window.location.origin;
        const requestedPage = '5';
        const countPage = 1;
        const divHtml = '';
        const plzField = document.querySelector('.field-plz');
        const selectField = document.querySelector('.form-select');
        const submitField = document.querySelector('.field-submit');
        let plzData = '';
        let selectData = '';

        function jsonResults(currentPage, requestedPage, countPage, divHtml, plzData, selectData) {
            divHtml = '';
            $.getJSON(currentPage + '?type=1377123&requestedPage=' + requestedPage + '&currentPage=' + countPage
                + '&postcode=' + plzData + '&targetgroup=' + selectData, (data) => {
                $('#foerdersuche-list').empty();
                $.each(data.foerderSuchePages, (key, value) => {
                    divHtml += `<div class="results-item"><div class="row"><div class="col-md-9">
            <h5 class="results-headline">` + value.title + `</h5>
            <p class="results-target"><b>Zielgruppe: </b>` + value.tx_foerdersuche_zielgruppe_text + `</p>
            <p class="results-funding"><b>Fördergegenstand: </b>` + value.tx_foerdersuche_foerdergegenstand + `</p>
            </div>
            <div class="col-md-3 d-flex align-items-stretch">
            <a href="` + value.slug + `" class="arrow-link">Mehr erfahren</a>
            </div>
            </div>
            </div>`;
                });
                $('#foerdersuche-list').append(divHtml);

                $('#foerdersuche-list').append('<div class="pagination-wrap">Insgesamt gibt es ' + data.totalFoerderSuchePages
                    + ' Ergebnis(se) | <span class="prev"></span> Seite ' + data.currentPage
                    + ' von ' + data.totalPages + ' <span class="next"></span></div>');
                if (data.totalPages > 1 && data.totalPages > countPage) {
                    $('.pagination-wrap .next').append('<a class="pagination next" data-countPage="' + (data.currentPage + 1) + '">weiter</a>');
                }
                if (data.totalPages > 1 && countPage > 1) {
                    $('.pagination-wrap .prev').append('<a class="pagination back" data-countPage="' + (data.currentPage - 1) + '">zurück</a>');
                }
                const target = document.querySelector('.pagination-wrap');
                const clonePagination = target.cloneNode(true);
                $('#foerdersuche-list').prepend(clonePagination);

                const pagination = document.querySelectorAll('.pagination');
                for (let i = 0; i < pagination.length; i++) {
                    const data = pagination[i].getAttribute('data-countPage');
                    pagination[i].addEventListener('click', () => {
                        jsonResults(currentPage, requestedPage, data, divHtml, plzData);
                    });
                }
            });
        }

        jsonResults(currentPage, requestedPage, countPage, divHtml, plzData, selectData);
        submitField.addEventListener('click', (e) => {
            e.preventDefault();
            plzData = plzField.value;
            selectData = selectField.value;
            jsonResults(currentPage, requestedPage, countPage, divHtml, plzData, selectData);
        });
    },
    chargingStations() {
        const detailPage = document.querySelector('#chargingstation-list').getAttribute('data-detail');
        const currentPage = window.location.origin;
        const requestedPage = '5';
        const countPage = 1;
        const divHtml = '';
        const filterHtml = '';
        const selectField = document.querySelector('.form-select');
        const submitField = document.querySelector('.field-submit');
        let selectData = '';

        function jsonFilterResults(currentPage, requestedPage, countPage, filterHtml) {
            $.getJSON(currentPage + '?&type=776776', (data) => {
                $.each(data.uniqueLocations, (key, value) => {
                    filterHtml += `<option value="${value}">${value}</option>`;
                });
                $('#chargingstation-filter .form-select').append(filterHtml);
            });
        }

        function jsonResults(currentPage, requestedPage, countPage, divHtml, selectData) {
            divHtml = '';
            $.getJSON(currentPage + '?&type=776776&requestedPage=' + requestedPage + '&currentPage='
                + countPage + '&location=' + selectData + '', (data) => {
                $('#chargingstation-list').empty();
                $.each(data.chargingStations, (key, value) => {
                    divHtml += `<div class="results-item">
<div class="row"><div class="col-md-9">
            <h5 class="results-ladesaeulenUnternehmensName">Deine ${value.companyName}</h5>
            <p class="results-itemLocation"><b>${value.location}, ${value.addressFirst}</b></p>
            </div>
            <div class="col-md-3 d-flex align-items-stretch">
            <a href="${detailPage}${value.detailSlug}/" class="arrow-link">Zur Detailseite</a>
            </div>
            </div>
            </div>`;
                });
                $('#chargingstation-list').append(divHtml);
                $('#chargingstation-list').append('<div class="pagination-wrap">Insgesamt gibt es ' + data.totalChargingStations
                    + ' Ergebnis(se) | <span class="prev"></span> Seite ' + data.currentPage + ' von ' + data.totalPages
                    + ' <span class="next"></span></div>');
                if (data.totalPages > 1 && data.totalPages > countPage) {
                    $('.pagination-wrap .next').append('<a class="pagination next" data-countPage="' + (data.currentPage + 1) + '">weiter</a>');
                }
                if (data.totalPages > 1 && countPage > 1) {
                    $('.pagination-wrap .prev').append('<a class="pagination back" data-countPage="' + (data.currentPage - 1) + '">zurück</a>');
                }

                setTimeout(() => {
                    const target = document.querySelector('.pagination-wrap');
                    if (target) {
                        const clonePagination = target.cloneNode(true);
                        $('#chargingstation-list').prepend(clonePagination);

                        const pagination = document.querySelectorAll('.pagination');
                        for (let i = 0; i < pagination.length; i++) {
                            countPage = pagination[i].getAttribute('data-countPage');
                            pagination[i].addEventListener('click', () => {
                                jsonResults(currentPage, requestedPage, countPage, divHtml, selectData);
                            });
                        }
                    }
                }, 1000);
            });
        }

        jsonResults(currentPage, requestedPage, countPage, divHtml, selectData);
        jsonFilterResults(currentPage, requestedPage, countPage, filterHtml);
        submitField.addEventListener('click', (e) => {
            e.preventDefault();
            selectData = selectField.value;
            jsonResults(currentPage, requestedPage, countPage, divHtml, selectData);
        });
    },
};
